import type { ReactNode } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectDomain, makeSelectUser } from '@webapp/core/stores/global'
import { buildAddLicensesUrl } from '@webapp/platform/iam/utils'

interface IAddLicensesLinkProps {
  children: ReactNode
}

export const AddLicensesLink = ({ children }: IAddLicensesLinkProps) => {
  const domain = useSelector(makeSelectDomain())
  const user = useSelector(makeSelectUser())

  const href = buildAddLicensesUrl({
    domain: domain ?? '',
    email: user?.email ?? '',
  })

  return (
    <a href={href} target='_blank' rel='noopener noreferrer'>
      {children}
    </a>
  )
}
